import { render } from "./HomeView.vue?vue&type=template&id=113ce4da&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=113ce4da&scoped=true&lang=less"

import exportComponent from "E:\\dbplas-zhixue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113ce4da"]])

export default __exports__